export * from './reviews-main/reviews-main.component';